export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    materials: 'New Carbon Materials',
    solventfree: 'Solvent-Free Adhesive',
    estersolvent: 'Ester Solvent Adhesive',
    alcoholicsolvent: 'Alcoholic Solvent Adhesive',
    news: 'News',
    support: 'Technical Support',
    hr: 'Human Resources',
    contact: 'Contact',
    more: 'More',
    language: 'Language'
  },
  menu: {
    loading: 'Loading...',
    home: 'Home',
    newCarbonMaterials: 'New Carbon Materials',
    adhesive: 'Adhesive',
    technicalSupport: 'Technical Support',
    newsCenter: 'News Center',
    humanResource: 'Human Resource',
    aboutUs: 'About Us',
    contactUs: 'Contact Us'
  },
  header:{
    menu: 'Menu',
    language: 'Language'
  },
  footer: {
    contactTitle: 'Feel free to contact us:',
    addressTitle: 'ADD:',
    address: '688 Xifeng Road, Nantaihu New Area, Huzhou City, Zhejiang Province, China',
    addressCn: '688 Xifeng Road, Nantaihu New Area, Huzhou City, Zhejiang Province, China'
  },
  languageDialog: {
    title: 'Choose Your Language',
    current: 'Current',
    switchSuccess: 'Language switched successfully',
    description: 'We are committed to providing multilingual support for global users, alstandarding more people to use our services conveniently.',
    contactNote: 'If you need support in other languages, please contact our customer service team.'
  },
  home: {
    title: 'Home',
    banner: {
      title: 'Global Vision, Local Service',
      subtitle: 'International team providing localized professional services',
      heroTitle: 'New Materials New Technology New Breakthroughs',
      heroSubtitle: 'Professional chemical product manufacturer, committed to providing customers with quality products and services',
      viewProducts: 'View Products',
      learnMore: 'Learn More'
    },
    about: {
      title: 'Company Profile',
      content: 'We are an enterprise focused on innovation and quality, committed to providing customers with the best products and services. Since our establishment, we have continuously pursued excellence, centered on customer needs, and continuously improved our products and services.',
      companyIntro: 'Huzhou Ochem Chemical Co., Ltd. is one of the subsidiaries of Carbon Material LLC based in Houston, Texas, USA, investing in China. The company is located in the convenient Yangtze River Delta city - Huzhou, near Hangzhou International Airport, Nanjing Lukou International Airport and Shanghai Pudong International Airport, with very convenient transportation.',
      companyPhilosophy: 'The company folstandards the business philosophy of "Integrity, Excellence, Innovation", with the vision of balancing human needs for energy and environment through innovation as the company\'s development vision, continuously promoting the industry toward green and environmental direction through in-depth research and development and continuously innovative products and application technologies.',
      viewMore: 'View More',
      viewDetails: 'View Details'
    },
    meta: {
      description: 'Huzhou Ochem Chemical Co., Ltd. - Professional chemical product manufacturer, committed to innovating to balance human energy and environmental needs'
    },
    products: {
      title: 'Our Products',
      product1: {
        name: 'Solvent-Free Adhesive',
        description: 'Environmentally friendly solvent-free composite adhesive for food packaging and other applications'
      },
      product2: {
        name: 'Ester Solvent Adhesive',
        description: 'High-performance ester solvent composite adhesive with excellent bonding strength'
      },
      product3: {
        name: 'Structural Engineering Adhesive',
        description: 'Professional structural engineering adhesive widely used in construction and industrial fields'
      }
    },
    advantages: {
      title: 'Our Advantages',
      innovation: {
        title: 'Technical Innovation',
        description: 'Continuous R&D investment, constantly launching innovative products and solutions'
      },
      quality: {
        title: 'Quality Assurance',
        description: 'Strict quality management system ensuring high quality and reliability of products'
      },
      environment: {
        title: 'Environmental Concept',
        description: 'Committed to green environmental protection, developing sustainable chemical products'
      },
      service: {
        title: 'Professional Service',
        description: 'Professional technical team providing comprehensive technical support for customers'
      }
    }
  },
  about: {
    title: 'About Us',
    subtitle: 'Learn about our history, mission and values',
    introHeader: 'Company Introduction',
    introTitle: 'Innovation to balance human needs for energy and the environment',
    companyIntro: 'Our company was founded in 2005, is an enterprise focused on high-tech product research and development and production. After years of development, we have become a leading enterprise in the industry, with products exported to many countries and regions around the world.',
    vr: {
      panoramicVR: 'Panoramic VR',
      visitUs: 'No need be present. Just visit us',
      slideMouse: 'Slide the mouse to continue your visit'
    },
    meta: {
      description: 'Learn about Huzhou Ochem Chemical Co., Ltd.\'s history, mission and values, we are committed to innovative research and development of chemical products'
    },
    teamIntro: 'We have a high-quality R&D team, continuously launching innovative products to meet market demands. Our production base is equipped with advanced production equipment and a complete quality management system, ensuring high quality and reliability of products.',
    philosophy: 'We adhere to the corporate philosophy of "Innovation, Quality, Integrity, Win-Win", committed to providing customers with the highest quality products and services, developing together with partners to achieve mutual benefits.',
    culture: {
      title: 'Corporate Culture',
      innovation: {
        title: 'Innovation',
        description: 'We are committed to technological innovation and product development, continuously launching new products that meet market demands'
      },
      quality: {
        title: 'Quality',
        description: 'Strict quality management system ensuring every product meets the highest standards'
      },
      integrity: {
        title: 'Integrity',
        description: 'Treating people with honesty and establishing business with trust, building long-term stable partnerships'
      },
      philosophy: {
        title: 'Philosophy',
        description: 'Innovation to balance human needs for energy and environment, promoting sustainable industrial development'
      }
    },
    timeline: {
      title: 'Development History',
      item1: {
        title: 'Company Establishment',
        description: 'Company invested $4 million to establish "Huzhou Ochem Chemical Co., Ltd." in Huzhou'
      },
      item2: {
        title: 'Production Commenced',
        description: 'The company was completed and put into production in May 2005'
      },
      item3: {
        title: 'New Product Development',
        description: 'Developed new functional water treatment fine chemicals and continuously innovated to develop environmentally friendly and high-efficiency water treatment products'
      },
      item4: {
        title: 'Product Expansion',
        description: 'To adapt to market demand, the company developed solvent-free polyurethane adhesive products'
      },
      item5: {
        title: 'Industrial Upgrade',
        description: 'Folstandarding the trend of the times, the company entered new energy and new materials industries, expanding its business model and scope, utilizing its chemical enterprise advantages to rapidly promote the development of new carbon materials'
      },
      item6: {
        title: 'Solvent Recovery',
        description: 'The company expanded into new solvent recovery fields, built NMP solvent purification production line for NMP solvent recycling'
      },
      item7: {
        title: 'Patent Achievements',
        description: 'As of this year, the company has obtained 11 authorized invention patents (including one US patent and one European patent)'
      },
      item8: {
        title: 'Capacity Expansion',
        description: 'Solvent-free adhesive product capacity increased from original annual capacity of 3,000 tons to 6,000 tons'
      },
      item9: {
        title: 'Market Recognition',
        description: 'Newly developed one-component solvent-free adhesive products gained widespread market recognition for performance and quality stability, occupying stable growing market share'
      },
      item10: {
        title: 'Product Diversification',
        description: 'Company\'s newly developed products including PVDC water-based primer, pharmaceutical packaging blister film composite adhesive, stretch-resistant cooking-resistant adhesive, aluminum alloy coating adhesive and wood paint gradually gaining market recognition'
      },
      item11: {
        title: 'R&D Center Construction',
        description: 'The company\'s new R&D center will begin construction, inviting talents to join in advance'
      }
    }
  },
  products: {
    title: 'Products',
    meta: {
      description: 'Huzhou Ochem Chemical Co., Ltd. Product Introduction - Soft packaging composite adhesives, engineering structural adhesives and other professional chemical products'
    },
    viewDetails: 'View Details',
    cancel: 'Cancel',
    jumpToDetails: 'Jump to detailed page',
    categories: {
      solventFree: {
        title: 'Solvent-Free Adhesive Series',
        description: 'High-performance solvent-free composite adhesive suitable for various packaging materials'
      },
      esterSolvent: {
        title: 'Ester Solvent Adhesive Series',
        description: 'Professional ester solvent composite adhesive with excellent bonding performance'
      }
    },
    solventFree: {
      product1: {
        application: 'Widely Application',
        infoLabel1: 'T.F ON ANSI 31-2024',
        infoValue1: 'PAA FAST DECAY',
        descriptions: [
          'Aromatic and Aliphatic mixed Isocyanate',
          '13°C AL RCPP cured resistant',
          'PAA in PootiStaff >0.01 mg/kg after being cured'
        ]
      }
    }
  },
  materials: {
    title: 'Materials',
    learnMore: 'Learn More',
    information: 'information',
    detailModal: {
      description: 'Product Description',
      specifications: 'Specifications',
      applications: 'Applications',
      features: 'Key Features',
      close: 'Close',
      contact: 'Contact Us'
    },
    material1: {
      category: 'Carbon Materials',
      title: 'New',
      description: 'Carbon is one of the most closely related and important elements that exist in nature. At the same time, because of its special microstructure, the carbon material composed of the sixty element has unique properties, and the nano-carbon phase, and now carbon materials are constantly being developed and artificially made.'
    },
    material2: {
      title: 'Carbon Nanotube',
      description: 'Carbon nanotube is a kind of nanomaterial that is formed. Its structural characteristics of extremely high order form. Adding it to the concrete cannot be the battery for effective conductivity to keep sufficient specific thermal capacity performance. As a conductive direction and lithium ion battery first and liquid conductivity.',
      placeholder: 'Carbon Nanotube Structure'
    },
    material3: {
      title: 'Conductive Slurry',
      description: 'Carbon transmission mixing point in the form of agglomeration with various crystalline slurries during the production process and lithium-ion and its sulfur-in-carbide component. As one of the carbon nanotubes in a liquid solvent system, with a content generally between 2-10% and a moderate viscosity, which brings great convenience to downstream applications.',
      placeholder: 'Conductive Slurry'
    },
    material4: {
      title: 'Nano Carbon Fiber',
      description: 'Carbon nanofiber is a kind of nanofiber that is continuously grown by vapor deposition method, with a diameter of 120-200 nanometers. It has the characteristics of high conductivity, high conductivity, high strength, good flexibility, and easy dispersion. It is indispensable for many conductive applications.',
      placeholder: 'Nano Carbon Fiber'
    },
    material5: {
      title: 'Composite Porous Graphite Material',
      description: 'Porous soft carbon is a synthetic carbon material with high specific surface, pore size and pore volume, as well as a certain graphite structure, so it is a special lithium battery anode material with fast charging and long-term performance. Through special formula and processing technology, the material has high capacity (>350 mah/g) and satisfactory first charge and discharge efficiency.',
      placeholder: 'Composite Porous Graphite'
    },
    material6: {
      title: 'New Product Under Development',
      description: 'With the development of science technology and the improvement of people\'s living standards, new carbon carbon materials has developed rapidly, and more and more carbon material products are expected to be produced.',
      placeholder: 'Research Equipment'
    }
  },
  news: {
    title: 'News Center',
    newsCenter: 'Corporate News',
    subtitle: 'Learn about the latest company dynamics and industry news',
    viewAll: 'View All News',
    developing: 'Show all news function in development',
    releaseTime: 'Release time',
    learnMore: 'Learn More',
    emptyHint: 'No news has been published yet. Please check back soon.',

    news1: {
      title: 'New Material Technology Breakthrough',
      summary: 'We have achieved major technological breakthroughs in carbon materials, new products will bring better solutions for customers...'
    },
    news2: {
      title: 'Green Environmental Production',
      summary: 'The company is committed to environmental production, adopting the latest clean technology to contribute to sustainable development...'
    },
    news3: {
      title: 'International Cooperation Project',
      summary: 'Reached strategic cooperation with internationally renowned enterprises to jointly promote R&D and application of new energy materials...'
    },
    news4: {
      title: 'R&D Team Expansion',
      summary: 'The company\'s R&D team continues to expand, attracting more industry experts to join our team...'
    },
    news5: {
      title: 'Product Quality Certification',
      summary: 'Our products have passed multiple international quality certifications, providing more reliable guarantee for customers...'
    },
    news6: {
      title: 'Technology Innovation Award',
      summary: 'The company won industry technology innovation award, demonstrating our outstanding achievements in technology R&D...'
    },
    news7: {
      title: 'Market Expansion Plan',
      summary: 'Formulated a new market expansion plan to further expand our market influence...'
    },
    news8: {
      title: 'Environmental Certification Obtained',
      summary: 'The company obtained multiple environmental certifications, reflecting our commitment to sustainable development...'
    },
    news9: {
      title: 'Digital Transformation',
      summary: 'Comprehensively promoting digital transformation to improve production efficiency and management level...'
    },
    news10: {
      title: 'Smart Manufacturing Upgrade',
      summary: 'Introducing the latest smart manufacturing technologies to achieve automation and intelligent management of production processes...'
    },
    news11: {
      title: 'Sustainable Development Strategy',
      summary: 'Formulating and implementing sustainable development strategies, fulfilling social responsibilities while ensuring economic benefits...'
    },
    news12: {
      title: 'Talent Development Program',
      summary: 'Launching comprehensive talent development programs to provide employees with more career advancement opportunities and skill enhancement...'
    },
    prevPage: 'Previous',
    nextPage: 'Next',
    viewingNews: 'Viewing News'
  },
  support: {
    title: 'Technical Support',
    download: 'Download',
    downloading: 'Downloading',
    document: 'document',
    downloadReady: 'is ready. In the production environment, this will trigger a real download.',
    downloadError: 'File temporarily unavailable, please try again later',
    documents: {
      doc1: {
        type: 'Technical Data Sheet',
        title: 'SF9310A-SF9310B TDS'
      },
      doc2: {
        type: 'Technical Data Sheet',
        title: 'SF9620A-SF9620B TDS'
      },
      doc3: {
        type: 'Technical Data Sheet',
        title: 'SF9270A-SF9270B TDS'
      },
      doc4: {
        type: 'Product Specification',
        title: 'Carbon Nanotube Product Specification'
      },
      doc5: {
        type: 'User Guide',
        title: 'Conductive Slurry User Guide'
      },
      doc6: {
        type: 'Application Guide',
        title: 'High Temperature Application Guide'
      },
      doc7: {
        type: 'Safety Data Sheet',
        title: 'Material Safety Data Sheet'
      },
      doc8: {
        type: 'Product Catalog',
        title: '2024 Product Catalog'
      },
      doc9: {
        type: 'Installation Manual',
        title: 'Product Installation Manual'
      },
      doc10: {
        type: 'Certification',
        title: 'ISO Certification'
      }
    }
  },
  hr: {
    title: 'Human Resources',
    subtitle: 'Join our team - Creating the future together',
    description: 'We are committed to providing excellent talent with broad development platforms and competitive compensation packages, looking forward to working with you to create a better future',
    joinUs: 'Please post to {email},Tel: {phone}.Our HR will contact you as soon as possible',
    currentOpenings: 'Current Openings',
    fields: {
      address: 'Address',
      branch: 'Branch',
      workingYears: 'Working Years',
      education: 'Education',
      hiring: 'Hiring',
      releaseDate: 'Release Date'
    },
    whyJoinUs: 'Why Join Us',
    keyRequirements: 'Key Requirements',
    applyNow: 'Apply Now',
    thankYou: 'Thank you for applying for',
    position: 'position',
    sendResume: 'We will process your application as soon as possible',
    expand: 'Show More',
    collapse: 'Show Less',
    fullRequirements: 'Complete Job Requirements',
    responsibilities: 'Job Responsibilities',
    benefits: 'Benefits',
    contactInfo: 'Contact Information',
  contactEmail: 'Email',
  contactPhone: 'Phone',
    noPositions: 'No current openings',
    jobs: {
      seniorEngineer: {
        title: 'Senior Materials Engineer',
        type: 'Full-time',
        location: 'Huzhou, China',
        experience: '3-5 Years',
        education: 'Master\'s Degree',
        salary: '¥20K-35K',
        description: 'Join our R&D team to develop next-generation carbon materials and innovative solutions for energy storage applications.',
        requirements: [
          'Master\'s degree in Materials Science, Chemical Engineering, or related field',
          '3+ years experience in carbon materials or composite materials R&D',
          'Proficiency in materials characterization techniques',
          'Strong analytical and problem-solving skills',
          'Excellent communication skills in English and Chinese'
        ],
        responsibilities: [
          'Lead carbon materials product development and improvement',
          'Design and execute experimental plans, analyze results',
          'Collaborate with cross-functional teams to advance projects',
          'Prepare technical reports and patent applications',
          'Participate in customer technical exchanges and product promotion'
        ],
        benefits: [
          'Competitive salary and compensation package',
          'Comprehensive social insurance and commercial medical insurance',
          'Annual health check-up',
          'Professional training and career development opportunities',
          'Flexible working hours and comfortable office environment'
        ]
      },
      rdScientist: {
        title: 'Research & Development Scientist',
        type: 'Full-time',
        location: 'Shanghai, China',
        experience: '2-4 Years',
        education: 'Bachelor\'s Degree',
        salary: '¥15K-25K',
        description: 'Contribute to innovative research projects focused on advanced carbon nanomaterials and their industrial applications.',
        requirements: [
          'Bachelor\'s degree in Chemistry, Materials Science, or related field',
          '2+ years experience in nanomaterials research',
          'Experience with synthesis and characterization of carbon materials',
          'Strong laboratory skills and attention to detail',
          'Ability to work independently and in team environments'
        ],
        responsibilities: [
          'Conduct synthesis and characterization of carbon nanomaterials',
          'Optimize material preparation process parameters',
          'Perform product performance testing and data analysis',
          'Assist in developing R&D project plans',
          'Collaborate with industrialization teams to advance technology transfer'
        ],
        benefits: [
          'Competitive base salary',
          'Comprehensive social insurance system',
          'Project bonuses and annual rewards',
          'Academic exchange and training opportunities',
          'Excellent R&D environment and equipment'
        ]
      },
      processEngineer: {
        title: 'Process Engineer',
        type: 'Full-time',
        location: 'Huzhou, China',
        experience: '1-3 Years',
        education: 'Bachelor\'s Degree',
        salary: '¥12K-20K',
        description: 'Optimize production processes to ensure quality and efficiency of carbon material products.',
        requirements: [
          'Bachelor\'s degree in Chemical Engineering or related field',
          '1+ years experience in chemical production',
          'Knowledge of quality control and safety protocols',
          'Strong analytical and problem-solving skills',
          'Good teamwork spirit'
        ],
        responsibilities: [
          'Supervise and optimize carbon material production processes',
          'Conduct process parameter adjustments and equipment maintenance',
          'Execute quality control procedures to ensure product specifications',
          'Analyze production data and propose improvements',
          'Participate in new process development and validation'
        ],
        benefits: [
          'Stable salary income',
          'Complete five social insurances and housing fund',
          'Skill enhancement training opportunities',
          'Job stability guarantee',
          'Good working environment and team atmosphere'
        ]
      }
    },
    culture: {
      innovation: {
        title: 'Innovation Driven',
        description: 'We encourage innovative thinking and invest in cutting-edge R&D, letting your creativity flourish here.'
      },
      growth: {
        title: 'Career Development',
        description: 'Comprehensive training system and promotion pathways to support your career growth and personal development.'
      },
      teamwork: {
        title: 'Teamwork',
        description: 'Diverse international team with an open and inclusive work environment, pursuing excellence together.'
      },
      benefits: {
        title: 'Benefits & Compensation',
        description: 'Competitive salary, comprehensive social benefits, annual health check-ups, team-building activities and more.'
      }
    }
  },
  contact: {
    title: 'Contact us',
    titleCard: 'Please contact us',
    subtitle: 'You can find me our contact information here',
    contactInfo: 'Contact',
    Tel: 'Tel',
    overseasOffice: 'Overseas Office',
    usOffice: 'Head Office in the USA',
    usAddress: 'Houston, Texas, USA',
    usAddressFull: '12603 Southwest Freeway, Suite 210 Stafford, Texas 77477 U.S.A',
    mapLoadError: 'Map loading failed, please try again later',
    mapAlt: 'Company Location Map - No.688 Xifeng Road, Nantaihu New Area, Huzhou City, Zhejiang Province, China',
    companyName: 'Huzhou Ochem Chemical',
    phoneConsultation: 'Phone Consultation',
    phoneHours: 'Mon-Fri 9:00-18:00',
    email: 'Email',
    emailNote: 'Reply within 24 hours',
    address: 'Address',
    addressNote: 'Nantaihu New Area, Huzhou City, Zhejiang Province, China',
    onlineSupport: 'Online Support',
    onlineSupportNote: 'Click to chat',
    supportHours: 'Weekdays 9:00-22:00',
    messageConsultation: 'Message Consultation',
    nameLabel: '* Name',
    namePlaceholder: 'Please enter your name',
    phoneLabel: 'Phone',
    phonePlaceholder: 'Please enter your phone',
    emailLabel: 'Email',
    emailPlaceholder: 'Please enter your email',
    companyLabel: 'Company',
    companyPlaceholder: 'Please enter your company',
    messageLabel: 'Message Content',
    messagePlaceholder: 'Please enter your message content',
    submit: 'Submit',
    reset: 'Reset',
    companyLocation: 'Company Location',
    companyFullName: 'Huzhou Ochem Chemical Co., Ltd',
    postalCode: 'Postal Code',
    loadingMap: 'Loading Map...',
    mapNote: 'In the actual project, Baidu Maps or Gaode Maps API can be integrated',
    nameRequired: 'Please enter name',
    emailInvalid: 'Please enter a valid email address',
    submitSuccess: 'Your message has been submitted successfully, we will contact you soon',
    calling: 'Calling 0572-2678666 for you',
    openingEmail: 'Opening email client for you',
    onlineServiceDeveloping: 'Online customer service function in development, please contact us by phone or email',
    emailSubject: 'Inquiry',
    emailBody: 'Hello, I would like to know more information.'
  },
  language: {
    title: 'Language Selection',
    subtitle: 'Please choose your preferred language',
    description: 'We are committed to providing multilingual support for global users, alstandarding more people to use our services conveniently.',
    contactNote: 'If you need support in other languages, please contact our customer service team.',
    current: 'Current Selection',
    switchSuccess: 'Language has been switched to:',
    chineseSimplified: 'Simplified Chinese',
    chineseTraditional: 'Traditional Chinese',
    english: 'English',
    spanish: 'Spanish',
    chineseSimplifiedDesc: 'Standard Chinese used in mainland China',
    chineseTraditionalDesc: 'Traditional Chinese used in Taiwan region',
    englishDesc: 'Standard American English',
    spanishDesc: 'Standard Spanish'
  },
  shareModal: {
    title: 'Share Page',
    selectPlatform: 'Select Platform',
    copyLink: 'Copy Link',
    copy: 'Copy',
    copySuccess: 'Link copied successfully!',
    wechatTip: 'WeChat sharing feature is under development, you can copy the link and share manually',
    shareToFacebook: 'Share to Facebook',
    shareToLinkedIn: 'Share to LinkedIn'
  },
  newsDetailModal: {
    title: 'News Details',
    publishTime: 'Publish Time',
    close: 'Close',
    loadError: 'Failed to load news details, please try again later'
  },
  languageWelcome: {
    title: 'Nice to meet you, please choose your language',
    subtitle: 'We provide multilingual support, please select your preferred language',
    note: 'You can change your language preference anytime in settings',
    switchSuccess: 'Language switched to:'
  },
  menuCarousel: {
    home: {
      title: 'Home',
      subtitle: 'Welcome to Huzhou Ochem Chemical',
      description: 'Professional chemical product manufacturer, committed to providing customers with quality products and services',
      viewMore: 'Learn More'
    },
    about: {
      title: 'About Us',
      subtitle: 'Innovation to balance human needs for energy and environment',
      description: 'Huzhou Ochem Chemical Co., Ltd., focused on high-tech product R&D and production, becoming a leading enterprise in the industry',
      viewMore: 'View Details'
    },
    solventFreeProducts: {
      title: 'SOLVENT FREE ADHESIVE',
      subtitle: 'Environmentally Friendly Solvent-Free Composite Adhesive',
      description: 'High-performance solvent-free composite adhesive suitable for food packaging and other applications, featuring environmental protection, safety, and efficiency',
      viewMore: 'View Products'
    },
    esterSolventProducts: {
      title: 'ESTER SOLVENT ADHESIVE',
      subtitle: 'High-Performance Ester Solvent Composite Adhesive',
      description: 'Professional ester solvent composite adhesive with excellent bonding performance, widely used in various packaging materials',
      viewMore: 'View Products'
    },
    alcoholicSolventProducts: {
      title: 'ALCOHOLIC SOLVENT ADHESIVE',
      subtitle: 'High-Performance Alcoholic Solvent Composite Adhesive',
      description: 'Professional alcoholic solvent composite adhesive with excellent bonding performance, widely used in various packaging materials',
      viewMore: 'View Products'
    },
    materials: {
      title: 'New Carbon Materials',
      subtitle: 'Advanced Carbon Material Technology',
      description: 'Mainly include carbon nanotubes and slurry, carbon nanofibers, multiple graphite-based anode materials, water-based binders and n-methylpyrrolidone',
      viewMore: 'Learn More'
    },
    news: {
      title: 'News Center',
      subtitle: 'Learn about the latest company dynamics',
      description: 'Get the latest company news and industry dynamics, learn about our latest progress in technological innovation and market expansion',
      viewMore: 'View News'
    },
    support: {
      title: 'Technical Support',
      subtitle: 'Professional Technical Documentation & Support',
      description: 'Provide complete technical data sheets, product specifications, user guides and other professional documents for comprehensive technical support',
      viewMore: 'Get Support'
    },
    hr: {
      title: 'Human Resources',
      subtitle: 'Join us, creating the future together',
      description: 'We sincerely invite talented individuals to join our team, offering competitive compensation and broad development opportunities',
      viewMore: 'View Positions'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with us anytime',
      description: 'We look forward to cooperating with you, providing professional consultation and service support through various channels',
      viewMore: 'Contact Info'
    }
  },
  productsPage: {
    pageTitle: 'Adhesive',
    title: 'Products',
    meta: {
      description: 'Huzhou Ochem Chemical Co., Ltd. Product Introduction - Soft packaging composite adhesives, engineering structural adhesives and other professional chemical products'
    },
    solventFree: {
      title: 'SOLVENT FREE ADHESIVE',
      subtitle: 'SOLVENT FREE ADHESIVE'
    },
    esterSolvent: {
      title: 'ESTER SOLVENT BASED ADHESIVE',
      subtitle: 'ESTER SOLVENT BASED ADHESIVE'
    },
    performanceLevel: 'Performance Level',
    icons: {
      lamination: {
        main: 'Lamination',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'Boiling 100°C/30min Transparent',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'Retort',
        sub: 'RETORT'
      },
      specialities: {
        main: 'Specialities',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'Chemical Resistance',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'High Performance',
      highSub: '高性能',
      medium: 'Medium Performance',
      mediumSub: '中性能',
      standard: 'Cost Effective',
      standardSub: '普通性能'
    },
    features: {
      chinese: 'Chinese Features',
      english: 'English Features'
    }
  },
  solventFreeProductsPage: {
    pageTitle: 'Solvent Free Adhesive',
    title: 'Solvent Free Adhesive - Products',
    meta: {
      description: 'Huzhou Ochem Chemical Co., Ltd. Product Introduction - Soft packaging composite adhesives, engineering structural adhesives and other professional chemical products'
    },
    solventFree: {
      title: 'SOLVENT FREE ADHESIVE',
      subtitle: 'Comprehensive First-Choice Adhesive for Soft Packaging Lamination'
    },
    performanceLevel: 'Performance Level',
    icons: {
      lamination: {
        main: 'Lamination',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'Boiling 100°C/30min Transparent',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'Retort',
        sub: 'RETORT'
      },
      specialities: {
        main: 'Specialities',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'Chemical Resistance',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'High Performance',
      highSub: '高性能',
      medium: 'Medium Performance',
      mediumSub: '中性能',
      standard: 'Cost Effective',
      standardSub: '普通性能'
    },
    features: 'Features'
  },
  esterSolventProductsPage: {
    pageTitle: 'Ester Solvent Based Adhesive',
    title: 'Ester Solvent Adhesive - Products',
    meta: {
      description: 'Huzhou Ochem Chemical Co., Ltd. Product Introduction - Soft packaging composite adhesives, engineering structural adhesives and other professional chemical products'
    },
    esterSolvent: {
      title: 'ESTER SOLVENT BASED ADHESIVE',
      subtitle: 'Comprehensive First-Choice Adhesive for Soft Packaging Lamination'
    },
    performanceLevel: 'Performance Level',
    icons: {
      lamination: {
        main: 'Lamination',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'Boiling 100°C/30min Transparent',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'Retort',
        sub: 'RETORT'
      },
      specialities: {
        main: 'Specialities',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'Chemical Resistance',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'High Performance',
      highSub: '高性能',
      medium: 'Medium Performance',
      mediumSub: '中性能',
      standard: 'Cost Effective',
      standardSub: '普通性能'
    },
    features: 'Features'
  },
  alcoholicSolventProductsPage: {
    pageTitle: 'Alcoholic Solvent Adhesive',
    title: 'Alcoholic Solvent Adhesive - Product Introduction',
    meta: {
      description: 'Huzhou Ochem Chemical Co., Ltd. Product Introduction - Soft packaging composite adhesives, engineering structural adhesives and other professional chemical products'
    },
    alcoholicSolvent: {
      title: 'Alcoholic Solvent Adhesive',
      subtitle: 'Comprehensive First-Choice Adhesive for Soft Packaging Lamination'
    },
    performanceLevel: 'Performance Level',
    icons: {
      lamination: {
        main: 'Lamination',
        sub: 'LAMINATION'
      },
      boiling: {
        main: 'Boiling 100°C/30min Transparent',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'Retort',
        sub: 'RETORT'
      },
      specialities: {
        main: 'Specialities',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: 'Chemical Resistance',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: 'High Performance',
      highSub: '高性能',
      medium: 'Medium Performance',
      mediumSub: '中性能',
      standard: 'Cost Effective',
      standardSub: '普通性能'
    },
    features: 'Features'
  },
  companyName: "Huzhou Ochem Chemical Co., Ltd."
}